import React, { useEffect, useState } from "react";
import CloneChildren from "@components/children";
import { getErrorMessageForId, getWidgetSpecificIsVisible } from "@utils/index";
import { ErrorMessage, Wrapper } from "./styles";

import { connect, useDispatch, useSelector } from "react-redux";
import { setPayloadData } from "@store/slices/globalState";
import { setAnalytics } from "@actions/setAnalyticsData";
import { useOnload } from "@utils/useOnLoad";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    ),
    errorMessage: getErrorMessageForId(
      state.configuration.normalisedConfig,
      ownProps.id
    ),
    globalPayloadData: state.globalState?.payloadData
  };
};

const QnaWidget = ({
  sub_heading,
  heading,
  options,
  onOptionClick,
  children,
  styles,
  actions,
  id,
  is_visible,
  errorMessage,
  inputState,
  cueTextStyles,
  headingStyles,
  prevInsurerText,
  prevInsurerExpiredText,
  isExpired,
  prev_insurer,
  start_date,
  wrapperStyles,
  checkOd = false,
  headingSecondary,
  ...props
}: any) => {
  const dispatch = useDispatch();
  const updatedProps = { parentId: id, ...props };
  const { payloadData, display_last_year_claim_question } = props;
  const propsToShare = inputState
    ? { ...updatedProps, inputState }
    : updatedProps;
  let is_hidden = false;
  if (
    display_last_year_claim_question === null ||
    display_last_year_claim_question === false
  ) {
    is_hidden = true;
  }

    const { hideCommercialField  } = useSelector(
      ({ globalState }: any) => {
        return {
          hideCommercialField: globalState?.hideCommercialField
        };
      }
    )
  const { on_load } = actions || {};
  // const hidePrevInsurerField =
  //   payloadData?.name === "previous_insurer_name" &&
  //   (payloadData?.value === "others" || payloadData?.value === null);

  const hideOdFlowPolicyStatus =
    payloadData?.name === "previous_policy_type" && !!checkOd;

  const hideCommercialFromEdit = id === "edit_mmv_details_commercial_qna" && hideCommercialField;  

  useOnload({ on_load, is_visible });

  useEffect(() => {
    const EXPIRED_STATUS = "+0-1";
    if (!!payloadData?.value && payloadData?.value != EXPIRED_STATUS) {
      dispatch(
        setPayloadData({
          [payloadData?.name]: payloadData?.value
        })
      );
      setAnalytics({
        [payloadData?.name]: payloadData?.value
      });
    }
  }, [payloadData?.value]);

  return !is_hidden &&
    is_visible &&
    !hideOdFlowPolicyStatus &&
    !hideCommercialFromEdit ? (
    <Wrapper wrapperStyles={wrapperStyles}>
      <div className="question" style={headingStyles}>
        {isExpired ? headingSecondary : heading}
      </div>
      {!!prev_insurer && !!start_date ? (
        <div className="cue-text" style={cueTextStyles}>
          {isExpired ? prevInsurerExpiredText : prevInsurerText}
        </div>
      ) : !!sub_heading ? (
        <div className="cue-text" style={cueTextStyles}>
          {sub_heading}
        </div>
      ) : (
        <></>
      )}
      <CloneChildren
        styles={{
          display: "flex",
          width: "100%",
          ...styles
          // justifyContent: "center"
        }}
        children={children}
        props={propsToShare}
      />
      {errorMessage ? <ErrorMessage>{errorMessage}</ErrorMessage> : null}
      <style jsx>
        {`
          .container {
            width: 85%;
            // border: 2px solid #ccc;
            // padding: 20px;
            // margin: 20px;
            // border-radius: 8px;
            // text-align: center;
          }

          .cue-text {
            font-size: 14px;
            color: #5b5675;
            margin-bottom: 16px;
            margin-top: -8px;
            font-weight: 400;
            line-height: 20px;
          }

          .question {
            font-size: 16px;
            color: #040222;
            margin-bottom: 16px;
            font-weight: 500;
            line-height: 24px;
          }

          @media (max-width: 768px) {
            .question {
              font-size: 14px;
              font-weight: 500;
              line-height: 20px;
              text-align: left !important;
            }

            .cue-text {
              font-size: 12px;
              font-weight: 400;
              line-height: 18px;
            }
          }
        `}
      </style>
    </Wrapper>
  ) : (
    <></>
  );
};

export default React.memo(connect(mapStateToProps)(QnaWidget));
